import { createReducer, on } from '@ngrx/store';
import { cargaCatalogos, cargaEmpresa, cargaModoEntrada, cargaTipo, cargaRemitente } from './actions';
import { iCatalogos, mCatalogos } from '../../entrada/entrada.interface';

export const initialState: iCatalogos = mCatalogos;

export const catalogoReducer = createReducer(
    initialState,
    on(cargaEmpresa, (state, payload) => {
        return { ...state, "catEmpresa": payload.catEmpresa };
    }),
    on(cargaModoEntrada, (state, payload) => {
        return { ...state, "catModoEntrada": payload.catModoEntrada };
    }),
    on(cargaTipo, (state, payload) => {
        return { ...state, "catTipo": payload.catTipo };
    }),
    on(cargaRemitente, (state, payload) => {
        return { ...state, "catRemitente": payload.catRemitente };
    }),
    on(cargaCatalogos, (state,  payload) => {
        return { ...state, ...payload.oCatalogos }
    })
);